<div class="sir-consent-row" [class.is-invalid]="showError">
    <input
        type="checkbox"
        [id]="id"
        [checked]="isChecked"
        [disabled]="isDisabled"
        [attr.aria-required]="isRequired ? 'true' : null"
        [attr.aria-invalid]="showError ? 'true' : null"
        [attr.aria-describedby]="showError ? errorId : null"
        (change)="onChange($event)"
        (blur)="onBlur()" />
    <label [for]="id" class="sir-text-style-system-l-default">
        <sirius-text-html
            [html]="labelHtmlKey | translate: labelHtmlTranslateParams"
            textStyle="system"
            textStyleSize="l"
            (click)="onLabelContentClick($event)"
            [class.sir-required-label]="isRequired"></sirius-text-html>
    </label>
</div>

<!-- @if (showError) {
    <span [id]="errorId" class="sir-error sir-text-style-system-s-default" role="alert">
        {{ errorText }}
    </span>
} -->

@if (dialogContent) {
    <sirius-modal2
        [(open)]="dialogOpen"
        [descriptionId]="dialogBodyId">
        <article class="sir-consent-dialog">
            <div class="sir-consent-dialog-content">
                <sirius-text-html
                    [id]="dialogBodyId"
                    [html]="dialogContent.bodyHtmlKey | translate"
                    textStyle="paragraph"
                    textStyleSize="m"></sirius-text-html>
            </div>
            <button
                type="button"
                siriusButton
                [buttonType]="'primary'"
                [buttonText]="dialogContent.buttonTextKey | translate"
                (click)="onDialogConfirm()"></button>
        </article>
    </sirius-modal2>
}
